'use client';

import React, { ReactNode } from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';
import { IExtraContent } from '@/features/client/Services/components/Content/ExtraContent/ExtraContent';
import chooseImage from '@/public/images/services/ac_installation/choose.jpg';
import installationImage from '@/public/images/services/ac_installation/installation-process.jpg';

import licensed from '@/public/images/services/ac_installation/licensed.png';
import energy from '@/public/images/services/ac_installation/energy.png';
import pricing from '@/public/images/services/ac_installation/pricing.png';
import customerService from '@/public/images/services/ac_installation/customer-service.png';
import tailored from '@/public/images/services/ac_installation/tailored.png';
import time from '@/public/images/services/ac_installation/time.png';
import warranty from '@/public/images/services/ac_installation/warranty.png';
import stayAtHome from '@/public/images/services/ac_installation/stay-at-home.png';
import measurement from '@/public/images/services/ac_installation/measurement.png';
import comfortControl from '@/public/images/services/air_conditioning/control.png';

interface Data {
  title: ReactNode;
  description: ReactNode;
  extraContent: IExtraContent[];
}

const data: Data = {
  title: '',
  description: '',
  image: image,
  offer_title: '',
  offer_data: [
    /* {
      title: 'Our Air Conditioning Installation Services',
      description:
        'Our high-profile AC installation company in San Diego provides services tailored to your cooling requirements. Whether it’s for your home or business, our experienced team ensures efficient and reliable installation, keeping your space comfortable all year round.',
      list: [
        {
          title: 'Residential AC Installation',
          description:
            'Stay cool at home with expertly installed air conditioning systems designed for your comfort and energy efficiency. We’ll help you pick and set up the superb AC unit to fit your space and budget.',
        },
        {
          title: 'Commercial AC Installation',
          description:
            'Our team specializes in installing high-performance cooling systems for offices, retail spaces, and other commercial buildings. We keep your business running smoothly and comfortably, even in peak summer heat.',
        },
        {
          title: 'Central Air Conditioning Installation',
          description:
            'Our central air conditioning installation provides consistent and even cooling throughout your property. We’ll guide you through choosing the right system for peak performance and reduced energy consumption.',
        },
        {
          title: 'Ductless Mini-Split Systems Installation',
          description:
            'Ideal for homes or offices without ductwork. Our <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">mini-split installation in San Diego</a> services provide targeted cooling with minimal disruption. These energy-efficient units are perfect for home additions, offices, or individual rooms.',
        },
      ],
    }, */
  ],
  // banner_title: `“Flexible Comfort Solutions”`,
  // banner_description: `Experience the convenience of ductless systems with Tytum. We provide expert installation and maintenance, delivering personalized comfort without the need for extensive ductwork.`,
  // banner_with_button: true,

  why_title: '',
  why_description: ``,
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Air Conditioning Installation Services We Offer in San Diego',
      description:
        'Our high-profile AC installation company in San Diego provides services tailored to your cooling requirements. Whether it’s for your home or business, our experienced team ensures efficient and reliable installation, keeping your space comfortable all year round.',
      image: image,
      items: [
        {
          title: 'Residential AC Installation',
          image: stayAtHome,
          description:
            'Stay cool at home with expertly installed air conditioning systems designed for your comfort and energy efficiency. We’ll help you pick and set up the superb AC unit to fit your space and budget.',
        },
        {
          title: 'Commercial AC Installation',
          image: customerService,
          description:
            'Our team specializes in installing high-performance cooling systems for offices, retail spaces, and other commercial buildings. We keep your business running smoothly and comfortably, even in peak summer heat.',
        },
        {
          title: 'Central Air Conditioning Installation',
          image: comfortControl,
          description:
            'Our central air conditioning installation provides consistent and even cooling throughout your property. We’ll guide you through choosing the right system for peak performance and reduced energy consumption.',
        },
        {
          title: 'Ductless Mini-Split Systems Installation',
          image: measurement,
          description:
            'Ideal for homes or offices without ductwork. Our <a href="https://tytum.com/services/heating-and-air/ductless-ac-installation">mini-split installation in San Diego</a> services provide targeted cooling with minimal disruption. These energy-efficient units are perfect for home additions, offices, or individual rooms.',
        },
      ],
      banner: {
        title: 'Book Your Air Conditioning Installation Today',
        description:
          'Experience the convenience of ductless systems with Tytum. We provide expert installation and maintenance, delivering personalized comfort without the need for extensive ductwork',
        bookServiceButton: true,
      },
    },
    {
      title: 'Why Choose Tytum for Your AC Installation in San Diego?',
      description:
        'With 20+ years of experience under our belt, the seasoned specialists at Tytum have accumulated a vast store of technical knowledge and hands-on skills to do our job to the highest standard. What makes us your number-one choice for air conditioner installers in San Diego, CA?',
      image: chooseImage,
      items: [
        {
          title: 'Licensed and Knowledgeable Technicians',
          image: licensed,
          description:
            ' Our team has the experience and know-how to get the job done right. We deliver every installation with unmatched expertise and safety.',
        },
        {
          title: 'Energy-Efficient Solutions',
          image: energy,
          description:
            'We prioritize green, energy-saving cooling solutions designed to reduce your monthly utility expenses. By choosing Tytum, you’ll enjoy long-term savings and a greener and more efficient cooling option.',
        },
        {
          title: 'Honest and Clear Pricing',
          image: pricing,
          description:
            'Say goodbye to hidden fees—our pricing is upfront and easy to understand. We present detailed estimates, so you’ll get full cost transparency from the start.',
        },
        /* {
          title: 'Great Customer Service',
          image: customerService,
          description:
            'Your satisfaction is vital for us. From start to finish, we uphold the highest standards, excellence, and a smooth, stress-free process.',
        }, */
        {
          title: 'Tailored Installations for Your Needs',
          image: tailored,
          description:
            ' We customize every AC installation to suit your space and preferences. Whether it’s for your home or business, let us assist you in finding a great solution for your cooling requirements.',
        },
        {
          title: 'Quick and Reliable Service',
          image: time,
          description:
            'We respect your schedule and strive to work diligently to complete installations without delays. Our goal is to get your new system up and running quickly.',
        },
        {
          title: 'Comprehensive Warranties',
          image: warranty,
          description:
            'Our installations include strong warranties for both parts and labor. Your investment is always secure and well-protected with Tytum.',
        },
      ],
      footerText:
        ' Choose Tytum for your AC installation in San Diego and experience the difference of expert service, quality systems, and customer care you can rely on.',
    },
    {
      title: 'Our Air Conditioner Installation Process',
      image: installationImage,
      description:
        'At Tytum, we make air conditioner installation straightforward and stress-free for our clients. Our detailed process ensures precision, comfort, and long-term satisfaction. Here’s how we work:',
      items: [
        {
          title: '1. Get Free Consultation',
          description:
            ' We begin with a free, no-pressure consultation to determine the best cooling setup for your space. This phase allows us to fully grasp your expectations and offer personalized recommendations for the best solutions.',
        },
        {
          title: '2. Customized Recommendations',
          description:
            'Based on your specific needs, we offer personalized options for air conditioning systems that match your preferences, budget, and energy efficiency goals.',
        },
        {
          title: '3. Expert Installation',
          description:
            'Our expert professionals install your system with care and attention to detail, offering great operation.',
        },
        {
          title: '4. Post-Installation Check',
          description:
            'After installation, we perform a thorough check to ensure everything meets top standards. Plus, we offer ongoing support to address any questions or maintenance needs.',
        },
      ],
    },
    {
      title: 'Signs It’s Time for a New AC Installation',
      description:
        'Today, many residential houses and business facilities across the US are equipped with air conditioners. But are you sure that your current AC system gives you the best value for the money? Here are three major telltale indicators that you should consider replacing it:',
      items: [
        {
          title: 'Your System Is Over 10-15 Years Old',
          image: time,
          description:
            'Any appliance has a lifespan limit. If your AC was installed a dozen years ago, its efficiency is subpar, and it’s living on borrowed time.',
        },
        {
          title: 'Energy Bills Keep Rising',
          image: energy,
          description:
            'Even when AC use remains the same, you pay an ever-increasing amount of money on electricity every month, which points to an overworked, struggling system.',
        },
        {
          title: 'Frequent Breakdowns and Repairs',
          image: pricing,
          description:
            "The air conditioner's downtime is dramatic, and you have to call for repairs each hot season (sometimes even twice). Definitely, it is more practical to acquire a new unit than to cover maintenance expenses that keep mounting over time.",
        },
      ],
    },
    {
      title: 'Benefits of a New AC Installation in San Diego',
      description:
        'Upgrading to a new air conditioning system provides a wide range of advantages that improve your comfort, reduce costs, and add value to your property. Here is why upgrading your AC is a smart choice:',
      items: [
        {
          title: 'Energy Efficiency',
          description:
            'Modern air conditioners are built for top performance while keeping energy use low. This allows you to cut down on utility costs and reduce carbon footprint.',
        },
        {
          title: 'Indoor Comfort',
          description:
            'A new system offers more consistent cooling and better humidity control, keeping your home or business comfortable even in the hottest weather.',
        },
        {
          title: 'Lower Maintenance Costs',
          description:
            'New air conditioning units require less frequent repairs and come with warranties, saving you money on maintenance and unexpected breakdowns. And if issues ever arise, our technicians are also available for fast and reliable <a href="https://tytum.com/services/heating-and-air/air-conditioning">air conditioner repair in San Diego</a> to keep your system running smoothly.',
        },
        {
          title: 'Increased Property Value',
          description:
            "Installing a new, energy-efficient air conditioning system can boost your property's resale value by appealing to buyers looking for modern and cost-effective solutions.",
        },
        {
          title: 'Quieter Operation',
          description:
            'Advanced technology in new units ensures quieter operation, allowing you to enjoy a more peaceful environment without disruptive noise.',
        },
        {
          title: 'Better Air Quality',
          description:
            'Many new systems come with advanced filtration that removes allergens, dust, and pollutants, providing cleaner and healthier air.',
        },
      ],
      footerText:
        ' By choosing a new air conditioning system, you’ll enjoy these advantages while ensuring long-term comfort and savings.',
      banner: {
        title: 'Book Your Air Conditioning Installation Today',
        description:
          'Ready to beat the heat? Stay cool and comfortable with expert air conditioner installation in San Diego, CA! Contact us today and enjoy the difference professional service makes.',
        bookServiceButton: true,
      },
    },
    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      items: [
        {
          title: '✓ How long does installation take?',
          description:
            'The process for air conditioning installation in San Diego CA typically takes 4-8 hours, depending on your system and home layout. Our team works efficiently to minimize disruptions.',
        },
        {
          title: '✓ What’s the cost of a new air conditioner?',
          description: (
            <>
              The cost of AC installation in San Diego varies based on the unit
              and project specifics.{' '}
              <a href="https://tytum.com/company/contact">Reach out</a> today
              for a personalized estimate that fits your budget.
            </>
          ),
        },
        /* {
          title: '✓ Can I install air conditioning myself?',
          description:
            ' Installing air conditioning requires technical expertise. Hiring a professional air conditioning installer in San Diego ensures safety, efficiency, and proper setup.',
        }, */
        {
          title:
            '✓ Do you offer air conditioning installations in San Diego for businesses?',
          description: (
            <>
              Yes! We practice both residential and commercial air conditioning
              installations in San Diego.{' '}
              <a href="https://tytum.com/company/contact">
                Contact us for tailored solutions.
              </a>{' '}
            </>
          ),
        },
        /* {
          title:
            '✓ What are the pros of hiring an expert for AC install in San Diego?',
          description:
            'Professionals provide precise installation, ensuring efficiency and system longevity. Trust our experts for a hassle-free AC install in San Diego.',
        }, */
        {
          title: '✓ What AC system works best for San Diego’s climate?',
          description:
            'High-SEER (Seasonal Energy Efficiency Ratio) central AC is ideal for buildings with existing ductwork, whereas ductless mini-splits are preferable for zonal cooling. However, electric heat pumps suit the city’s mild climate and temperate winters best, as they offer 300%+ energy efficiency, which is essential for mitigating the high utility prices San Diego charges.',
        },
        {
          title: '✓ How does San Diego’s coastal air affect my AC system?',
          description:
            'Unless your AC model is equipped with coated coils, maritime air, combined with dust, can cause severe salt-air corrosion of the condenser coils, fins, and electrical components, potentially leading to system failure within 5 years. To minimize adverse developments, rinse the outdoor unit regularly and apply anti-corrosion spray to the cabinet and coils. Professional maintenance for early corrosion detection is also recommended.',
        },
      ],
      footerText:
        'Count on us as your trusted provider for <a href="https://tytum.com/services/heating-and-air/heating-installation">heating installation in San Diego</a>, ensuring your home’s comfort and safety. Contact us or check out our services! 😊',
    },
  ],
};

const AirConditioningInstallation = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Service Details"
          title="Trusted AC Installation Services in&nbsp;San&nbsp;Diego"
          description="During the long, hot summers of Southern California, powerful, reliable air conditioning is not a whim but a vital necessity. Tytum’s vetted AC installers in San Diego provide quick, skilled installation services so you can enjoy a comfortable temperature in your home or office year-round, no matter the weather outside.<br />Book an air conditioning installation in San Diego"
          // description="Stay cool with highly skilled AC installation in San Diego. We ensure a smooth installation process with maximum efficiency for year-round comfort."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default AirConditioningInstallation;
